<template>
  <div class="neilian">
    <iframe v-if="show" :src="url" style="height: 800px;width:1200px;margin:0 auto;" frameborder="0"></iframe>
  </div>
</template>

<script>
import { authChemicalDay } from "@/api/oilBenzene";
export default {
  name: "relatedProducts",
  data() {
    return {
      show: false,
      url: 'http://groupapp.risun.com:9003/ZBZHReport/ReportServer?reportlet=RISUN%2F%5B5546%5D%5B54c1%5D%5B7814%5D%5B7a76%5D%2F%5B5316%5D%5B5de5%5D%5B5173%5D%5B8054%5D%5B4ef7%5D%5B683c%5D%5B66f4%5D%5B65b0%5D.cpt'
    }
  },
  created() {
    this.showPage();
  },
  methods: {
    showPage() {
      authChemicalDay().then((res) => {
        if (res.msg) {
          this.show = true;
        }
      });
    }
  } 
}
</script>

<style scoped>
.neilian {
  height: 800px;
  width: 1200px;
  margin: 30px auto;
  text-align: center;
}
</style>
